import _                           from 'underscore';
import React, { FC, ReactNode }    from 'react';
import { Icon, List, ListProps }   from 'semantic-ui-react';
import { SystemAccountingQueries } from '../../../queries';
import { CorvalAccount, Uuid }     from '../../../types';
import { UserLink }                from '../../pages/users/UserLink';
import { ListFromQuery }           from '../from-query/ListFromQuery';
import { UserAvatar }              from '../user-avatar/UserAvatar';
import { Cell, Grid }              from 'styled-css-grid';
import { EmptyCollectionMessage }  from "../util/messaging/EmptyCollectionMessage";


export interface OrganizationalUserListProps {
    userIds: Uuid[],
    organizationId: Uuid,
    listChildComponent?: FC<{ user: CorvalAccount }>
    horizontal?: boolean,
    columns?: 2 | 3 | 4 | 5 | 6,
    noItemsComponent?: ReactNode,

    [ additionalProps: string ]: any
}

const defaultProps: OrganizationalUserListProps = {
    userIds:            null,
    listChildComponent: null,
    organizationId:     null,
    horizontal:         false,
    columns:            2,
    noItemsComponent:   <EmptyCollectionMessage/>,
}

const OrganizationalUserList: FC<OrganizationalUserListProps> = ( _props ) => {

    let { userIds, organizationId, ...props } = _props;

    if( !userIds || _.isEmpty( userIds ) || !organizationId ) return <>{ props.noItemsComponent ?? null } </>;

    return (

        <ListFromQuery
            query={ SystemAccountingQueries.queries.GET_ORGANIZATION( `
				organizationMembers{
					accountId
					account{
						id
						emailAddress
						firstName
						lastName
						systemRole
						businessFunctions
						createdUtc
						updatedUtc
					}
				}`
            ) }
            queryOptions={ {
                variables: { id: organizationId }
            } }
            queryResultObject={ data => {
                return _.chain( data.organizations[ 0 ].organizationMembers )
                        .pluck( 'account' )
                        .filter( ( member: CorvalAccount ) => _.contains( userIds, member.id ) )
                        .sortBy( 'lastName' )
                        .value();
            } }
            loadingComponent={ () => <><Icon loading name='circle notch'/> Finding users...</> }
            noItemsComponent={ () =>
                <Icon.Group>
                    <Icon size='small' color='red' name='dont'/>
                    <Icon color='black' name='users'/>
                </Icon.Group>
            }
            containerComponent={ ( props: ListProps ) => (
                _props.horizontal
                ? <Grid columns={ `repeat(${ _props.columns },1fr)` } columnGap={ '10px' } rowGap={ '5px' }>{ props.children }</Grid>
                : <List relaxed divided { ...props } />
            ) }
            itemComponent={ ( data: ( { item: CorvalAccount } ) ) => {

                let UserComponent = props.listChildComponent;

                let user = ( _.isNull( UserComponent ) )
                           ? <UserLink organizationId={ organizationId } accountId={ data.item.id }>
                               <UserAvatar user={ data.item } asInitials={ true } withName={ true }/>
                           </UserLink>
                           : <UserComponent user={ data.item }/>;

                return (
                    _props.horizontal
                    ? <Cell key={ data.item.id }>{ user }</Cell>
                    : <List.Item key={ data.item.id }>{ user }</List.Item>
                );

            } }/>
    )
        ;
};

OrganizationalUserList.defaultProps = defaultProps;

export { OrganizationalUserList }
